import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from '@services/ui/validation.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { InputComponent } from '@shared/components/input/input.component';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-forgot-password-modal',
	imports: [SharedModule, InputComponent, ButtonComponent],
	templateUrl: './forgot-password-modal.component.html',
	styleUrl: './forgot-password-modal.component.scss',
})
export class ForgotPasswordModalComponent {
	@Input() show = false;
	@Output() showChange = new EventEmitter<boolean>();
	@Output() submit = new EventEmitter<string>();

	forgotForm: FormGroup;

	constructor(
		private fb: FormBuilder,
		private validationService: ValidationService,
	) {
		this.forgotForm = this.fb.group({
			email: ['', [Validators.required, this.validationService.emailValidator()]],
		});
	}

	onSubmit(): void {
		if (this.forgotForm.valid) {
			this.submit.emit(this.forgotForm.get('email')?.value);
			this.showChange.emit(false);
		} else {
			this.forgotForm.markAllAsTouched();
		}
	}

	onClose(): void {
		this.showChange.emit(false);
	}

	getErrorMessage(fieldName: string): string {
		const control = this.forgotForm.get(fieldName);
		if (!control?.errors || !control.touched) return '';

		const errorKey = Object.keys(control.errors)[0];
		return errorKey ? this.validationService.getValidatorErrorMessage(errorKey) : '';
	}
}
